import { useGetPermissionsQuery } from 'app/api';
import { useAuthorizationSlice } from 'app/containers/Authorization/slice';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useGetPermissions = () => {
  const envId = useSelector(selectSelectedEnvId);
  const authActions = useAuthorizationSlice().actions;
  const dispatch = useDispatch();

  const { data: permissions } = useGetPermissionsQuery(
    {
      envId: envId as number,
    },
    { skip: !envId },
  );

  useEffect(() => {
    if (permissions) {
      const companiesWithAnalyticsPermission =
        permissions?.permissionsByCompany
          .filter(companyPermissions => companyPermissions.analyticsPermission)
          .map(companyPermssions => companyPermssions.company.id) || [];

      const companiesWithRecommendationPermission =
        permissions?.permissionsByCompany
          .filter(
            companyPermissions => companyPermissions.recommendationPermission,
          )
          .map(companyPermssions => companyPermssions.company.id) || [];

      dispatch(
        authActions.setPermissionsByCompany({
          analytics: companiesWithAnalyticsPermission,
          recommendation: companiesWithRecommendationPermission,
        }),
      );
    }
  }, [permissions, authActions, dispatch]);

  return Boolean(permissions);
};

export default useGetPermissions;
